import {Device} from '@/models/Device'

export const LEVEL_BASE = 0
export const LEVEL_INFO = 5
export const LEVEL_WARNING = 10
export const LEVEL_ALERT = 20

export interface Event
{
    id: number
    level: EventLevel
    levelLabel?: string
    type: EventType
    typeLabel?: string
    deviceId?: number
    device?: Device
    isActual: boolean
    occurredAt: string
    extra: object
}

export type EventLevel =
    | typeof LEVEL_BASE
    | typeof LEVEL_INFO
    | typeof LEVEL_WARNING
    | typeof LEVEL_ALERT

export type EventType = string

export interface EventExtraDeviceEmission {
    id: number
    name: string
    isEmitting: string
}

export function getEventExtraDeviceEmissions(event: Event): EventExtraDeviceEmission[] {
    if (!event.extra) {
        return []
    }

    const extra = event.extra as {type: string, data: object[]}

    if (extra.type !== 'deviceEmissions') {
        return []
    }

    const data = extra.data as EventExtraDeviceEmission[]

    return [...data].sort((a: EventExtraDeviceEmission, b: EventExtraDeviceEmission) => (b.isEmitting ? 1 : 0) - (a.isEmitting ? 1 : 0))
}